export default {
    confirm_delete_title: 'Delete Record?',
    confirm_delete_text: 'Are you sure you want to delete record?',
    confirm: 'Confirm',
    power_confirm:
        'This can affect the processes that are active on the server!',
    change_server_info:
        'Are you sure you want to change the server information?',
};
